export const contractDetailsLabelKeysMapping = {
  nameOfCustomer: "Name of Customer",
  product: "Product",
  deposit: "Deposit",
  weeklyRechargeAmount: "Weekly Recharge Amount",
  numberOfWeeks: "Number of Weeks",
  totalPrice: "Total Price",
  upfrontPrice: "Upfront Price",
};

export const termsAndConditions = [
  {
    id: 1,
    content:
      "Sale and Payment: In consideration of the purchase price set out in Paragraph above, Sun King has agreed to sell to and the buyer has agreed to purchase the identified Products)",
  },
  {
    id: 2,
    content:
      "The Buyer will pay the Deposit and the Daily Recharge Amount via Mpesa and Airtel Money as outlined below:",
    subList: [
      {
        id: 1,
        content:
          "The lamp will be automatically switched off if the payment is not made on or before the due date or if the payment is made incorrectly. On making payment, the Buyer shall receive: a keycode via SMS on their registered phone number which needs to be entered on the keypad provided on the Product(s) for the Product(s) to work. In case of any query, the Buyer can contact the Energy Officer or visit the nearest Sun King Store. The Buyer can also contact Sun King's call center for FREE on 0800724878, +254 709 474 474 or USSD code .305#.",
      },
      {
        id: 2,
        content:
          "The risk in and control of the Product(s) shall pass to the Buyer once the Buyer takes possession of the Product(s). However, the legal title to the Product(s) shall not pass to the Buyer until Sun King receives payment in full for the Product(s). All intellectual properties in and to the Product would always belong to Sun King.        ",
      },
      {
        id: 3,
        content:
          "The Buyer is eligible for replacements under Sun King's warranty policy within 2 years of the purchase. The warranty policy does not cover defects due to normal wear and tear and is void if the product has been tampered with, abused, misused, damaged, or in case of fraud. All components are covered under the 2-year warranty period except for accessories (radio, stoves) and phones which have a 1-year warranty period.",
      },
      {
        id: 4,
        content:
          "The Buyer shall (i) make all payments due in a timely manner; (ii) use the Product(s) in a careful and proper manner; (iii) keep the Product(s) in good working order; (iv) not, whether by himself, his agents or any other person acting under his authority, interfere with the firmware functionality or tamper with the Product(s) before the Price is fully paid. Any attempt to do so, voids the warranty of the device and may be considered a criminal offense and is prosecutable under the law. (v) be responsible for ensuring the contact details held by Sun King are accurate and remain current.",
      },
    ],
  },
  {
    id: 3,
    content:
      "Notwithstanding anything to the contrary contained herein, the Buyer agrees that if the Buyer fails to make payment on the due date and fails to remedy such breach within seven (7) days of being notified to do so, then, without limiting any other right or remedy Sun King may have, and in compliance with relevant laws and regulations;",
    subList: [
      {
        id: 1,
        content:
          "Sun King may at any time require the Buyer to return the Product(s) to Sun King      ",
      },
      {
        id: 2,
        content:
          "if the Buyer fails to do so promptly, Sun King may enter the premises of the Buyer or where the Product(s) is/are located in order to recover/repossess them.",
      },
    ],
  },
  {
    id: 4,
    content:
      "In addition to the above, Sun King also reserves all the rights and remedies, including specific performance or any or other equitable remedy, available to it under law or otherwise, to enforce the provisions of this Agreement, more specifically for any breach or default by the Buyer, hereunder.",
  },
  {
    id: 5,
    content:
      "Carbon Credits: Carbon credits resulting from the sale under this agreement can be sold, assigned, or pledged at the full discretion of Sun King.",
  },
  {
    id: 6,
    content:
      "All rights and titles to the emission reductions generated by the solar home system sold in the counties covered by the KOSAP program are hereby ceded and granted to Rural Electrification and Renewable Energy Corporation (REREC). Sun King commits not to sell, transfer, assign, license, dispose of, grant or otherwise create any interest in the emission reductions generated by the solar home systems to any other party",
  },
  {
    id: 7,
    content:
      "The Buyer explicitly consents to, and authorizes, Sun King to collect, store, utilize, transfer, and/or report all personal data and payment history relating to the purchase and use of the goods and services sold. The Buyer also consents that Sun King may also use GPS or other location-tracking technology to determine product location or any other activities related to monitoring the use and function of the product. Sun King will use personal data collected solely for the purposes of selling to and servicing the customer, and if required, for reporting credit-related information to an authorized credit reference bureau or collection agency. For products under the category of smartphone devices, once the product is fully paid off the customer may visit one of our stores to disable or remove the location tracking functionality, at their discretion and at no cost to them. Sun King also reserves the right to share anonymized, aggregated data with third parties. Except as specified below in clause 13.",
  },
  {
    id: 8,
    content:
      "Sun King is hereby permitted to share unit/ of customer/ payment data of units sold in the counties covered by the KOSAP program with the IVA/ Manager of the KOSAP program. This data shall not be anonymized. For other third parties this data shall be anonymized.",
  },
  {
    id: 9,
    content:
      "This agreement and any dispute or claim arising out of or in connection with it or its subject matter or formation (including non-contractual disputes or claims) shall be governed by and construed in accordance with the laws of Kenya. Each party irrevocably agrees that the courts of Kenya shall have exclusive jurisdiction to settle any dispute or claim arising out of or in connection with this agreement or its subject matter or formation; and",
  },
  {
    id: 10,
    content:
      "This agreement constitutes a valid and binding obligation of each Party and is enforceable against it in accordance with its terms.",
  },
  {
    id: 11,
    content:
      "Sun King may at any time assign, charge, subcontract, delegate, declare trust over or deal in any other manner with any or all of its rights and obligations under this Agreement.",
  },
  {
    id: 12,
    content:
      "The Buyer shall not assign, transfer, mortgage, charge, subcontract, delegate, declare trust over or deal in any other manner with any of its rights and obligations under this Agreement, without Sun King's prior written consent.",
  },
  {
    id: 13,
    content:
      "Sun King, at its own discretion, may process a deposit refund to the buyer if the unit is returned within the period stipulated in the Sun King policy subject to the returned product being complete and in good working order after examination by Sun King. The buyer shall however be fully liable for any damaged or missing components when returning the unit.",
  },
];
